import { render, staticRenderFns } from "./ViewHackathon.vue?vue&type=template&id=4936e147&"
import script from "./ViewHackathon.vue?vue&type=script&lang=js&"
export * from "./ViewHackathon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports